<template>
  <div class="module-container">

    <div class="stats-header">
      <div class="stats-title">设备运行记录统计</div>
      <span class="more-link" @click="goToDeviceOperRecords">查看更多</span>
    </div>

    <div class="data-section">
      <div class="section-title">换热站水系统运行平均数据</div>
      <div class="data-grid">
        <div class="data-item" v-for="item in heatData" :key="item.label">
          <div class="item-label">{{ item.label }}</div>
          <div class="item-value">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <div class="data-section">
      <div class="section-title">洁净空调机房运行平均数据</div>
      <div class="data-grid">
        <div class="data-item" v-for="item in airConditionData" :key="item.label">
          <div class="item-label">{{ item.label }}</div>
          <div class="item-value">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <div class="data-section">
      <div class="section-title">变电所运行平均数据</div>
      <div class="data-grid wide">
        <div class="data-item" v-for="item in powerData" :key="item.label">
          <div class="item-label">{{ item.label }}</div>
          <div class="item-value">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <div class="data-section">
      <div class="section-title">生活水箱房运行平均数据</div>
      <div class="data-grid two-col">
        <div class="data-item" v-for="item in waterData" :key="item.label">
          <div class="item-label">{{ item.label }}</div>
          <div class="item-value">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOperationAvgData } from '@/api/deviceStatisticalAnalysis/operationData'
import { addDate, getCurTimeYMD } from '@/utils/index'
export default {
  name: 'OperationData',
  data() {
    return {
      heatData: [],
      airConditionData: [],
      powerData: [],
      waterData: [],
      refreshInterval: null
    }
  },
  mounted() {
    this.fetchOperationAvgData()
    // 设置定时刷新，每30分钟刷新一次
    this.refreshInterval = setInterval(this.fetchOperationAvgData, 1800000)
  },
  beforeDestroy() {
    // 清除定时器，避免内存泄漏
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    async fetchOperationAvgData() {
      // 先清空数据，确保即使数据不变也能触发重新渲染
      this.heatData = []
      this.airConditionData = []
      this.powerData = []
      this.waterData = []
      try {
        const postData = {
          projectId: JSON.parse(window.localStorage.userInfo).projectId,
          startDate: addDate(getCurTimeYMD(), -365),
          endDate: getCurTimeYMD()
        }
        const { data } = await getOperationAvgData(postData)
        console.log(data)

        // 处理换热站数据
        if (data && data.data.heatExchangeStationAvgData) {
          this.heatData = data.data.heatExchangeStationAvgData.avgDataItems.map(item => ({
            label: item.fieldName,
            value: `${item.avgValue}${item.unit}`
          }))
        } else {
          this.heatData = []
        }

        // 处理洁净空调机房数据
        if (data && data.data.cleanAirConditionerAvgData) {
          this.airConditionData = data.data.cleanAirConditionerAvgData.avgDataItems.map(item => ({
            label: item.fieldName,
            value: `${item.avgValue}${item.unit}`
          }))
        } else {
          this.airConditionData = []
        }

        // 处理变电所数据
        if (data && data.data.substationAvgData) {
          this.powerData = data.data.substationAvgData.avgDataItems.map(item => ({
            label: item.fieldName,
            value: `${item.avgValue}${item.unit}`
          }))
        } else {
          this.powerData = []
        }

        // 处理生活水箱房数据
        if (data && data.data.waterTankAvgData) {
          this.waterData = data.data.waterTankAvgData.avgDataItems.map(item => ({
            label: item.fieldName,
            value: `${item.avgValue}${item.unit}`
          }))
        } else {
          this.waterData = []
        }
      } catch (error) {
        console.error('获取运行数据失败:', error)
        this.heatData = []
        this.airConditionData = []
        this.powerData = []
        this.waterData = []
      }
    },
    goToDeviceOperRecords() {
      // 获取用户权限
      const userRoles = JSON.parse(decodeURI(window.localStorage.userRoles))
      // 计算日期参数
      const startDate = addDate(getCurTimeYMD(), -365)
      const endDate = getCurTimeYMD()

      // 检查是否有设备运行记录权限
      if (userRoles && userRoles.includes('equ_shebeiyunxingjilu')) {
        // 有权限，跳转到设备运行记录
        this.$router.push({
          path: '/deviceStatisticalAnalysis/deviceFileMan/deviceOperRecords',
          query: {
            startDate,
            endDate
          }
        });
      } else {
        // 无权限，提示
        this.$message({
          type: 'warning',
          message: '您暂无权限访问设备运行记录'
        });
      }
    }
  }
}
</script>

<style scoped>
.module-container {
  display: flex;
  flex-direction: column;
  margin: 20px 0;
}

.stats-header {
  height: 33px;
  position: relative;
  background-image: url(../../../../static/image/six/title.png);
  background-repeat: no-repeat;
  background-position: left;
  background-size: auto 100%;
}

.stats-title {
  position: absolute;
  top: 0;
  left: 38px;
  font-family: YouSheBiaoTiHei;
  font-weight: 400;
  font-size: 19px;
  color: #FFFFFF;
}

.more-link {
  position: absolute;
  top: 50%;
  right: 10px;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s;
  transform: translateY(-50%);
}

.more-link:hover {
  text-decoration: underline;
}

.data-section {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 15px;
}

.section-title {
  font-family: YouSheBiaoTiHei;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  margin-bottom: 10px;
  font-weight: 600;
  text-align: center;
  padding: 5px 0;
}

.data-grid {
  background-image: url(../../../../static/image/six/equipment-bg3.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
  flex: 1;
}

.data-grid.wide {
  grid-template-columns: repeat(5, 1fr);
  background-image: url(../../../../static/image/six/equipment-bg2.png);
}

.data-grid.two-col {
  grid-template-columns: repeat(2, 1fr);
  background-image: url(../../../../static/image/six/equipment-bg1.png);
}

.data-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  transition: all 0.3s;
  height: 45px;
  cursor: pointer;
  border-radius: 4px;
  padding: 5px;
}

.item-label {
  font-size: 11px;
  color: #fff;
  text-align: center;
  line-height: 1.3;
}

.item-value {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}
</style>
